<div>
  <ion-text color="primary"><h2>{{ [data.translationKey, 'help_dialog', 'title'].join('.') | translate }}</h2></ion-text>
  <ion-text>{{ [data.translationKey, 'help_dialog', 'text'].join('.') | translate }}</ion-text>

  <ion-text color="primary"><h2>{{ 'WORD_GUESS.help_dialog.mechanics.howto.title' | translate }}</h2></ion-text>
  <ion-text *ngIf="!isMobile">{{ 'WORD_GUESS.help_dialog.mechanics.howto.text.desktop' | translate }}</ion-text>
  <ion-text *ngIf="isMobile">{{ 'WORD_GUESS.help_dialog.mechanics.howto.text.mobile' | translate }}</ion-text>

  <ion-text color="primary"><h2>{{ 'WORD_GUESS.help_dialog.mechanics.cursor.title' | translate }}</h2></ion-text>
  <ion-text *ngIf="!isMobile">{{ 'WORD_GUESS.help_dialog.mechanics.cursor.text.desktop' | translate }}</ion-text>
  <ion-text *ngIf="isMobile">{{ 'WORD_GUESS.help_dialog.mechanics.cursor.text.mobile' | translate }}</ion-text>

  <ion-text color="primary"><h2>{{ 'WORD_GUESS.help_dialog.mechanics.colors.title' | translate }}</h2></ion-text>
  <div class="word-guess-help-legend">
    <div class="word-guess-help-legend-row">
      <span class="word-guess-help-tile is-correct">A</span>
      <ion-text>{{ 'WORD_GUESS.help_dialog.mechanics.colors.correct' | translate }}</ion-text>
    </div>
    <div class="word-guess-help-legend-row">
      <span class="word-guess-help-tile is-present">B</span>
      <ion-text>{{ 'WORD_GUESS.help_dialog.mechanics.colors.present' | translate }}</ion-text>
    </div>
    <div class="word-guess-help-legend-row">
      <span class="word-guess-help-tile is-absent">C</span>
      <ion-text>{{ 'WORD_GUESS.help_dialog.mechanics.colors.absent' | translate }}</ion-text>
    </div>
  </div>

  <ion-text color="primary"><h2>{{ 'WORD_GUESS.help_dialog.mechanics.umlauts.title' | translate }}</h2></ion-text>
  <ion-text>{{ 'WORD_GUESS.help_dialog.mechanics.umlauts.text' | translate }}</ion-text>
</div>
